import React, { useEffect, useMemo } from 'react';
import { retroCreateModalEntryPoint } from '@atlassian/jira-confluence-sprint-retro-create-modal/entrypoint';
import { useRetros } from '@atlassian/jira-confluence-sprint-retros/src/controllers/index.tsx';
import { ModalEntryPointContainer } from '@atlassian/jira-entry-point-modal-container';
import { useEntryPoint } from '@atlassian/jira-entry-point/src/controllers/use-entry-point/index.tsx';

const entryPointParams = {};
export default function ConfluenceRetroCreateModal() {
	const [state, actions] = useRetros();

	const { entryPointActions, entryPointReferenceSubject } = useEntryPoint(
		retroCreateModalEntryPoint,
		entryPointParams,
	);

	// eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
	useEffect(() => {
		if (state.loadCreateRetroModal) {
			actions.setLoadCreateRetroModal(false);
			entryPointActions.load();
		}
	}, [state.loadCreateRetroModal, actions, entryPointActions]);

	const props = useMemo(() => ({}), []);

	return (
		<ModalEntryPointContainer
			entryPointReferenceSubject={entryPointReferenceSubject}
			entryPointActions={entryPointActions}
			id="jira-confluence-sprint-retro-create-modal"
			packageName="jira-confluence-sprint-retro-create-modal"
			teamName="mdt-zora"
			runtimeProps={props}
		/>
	);
}
